module.exports = __webpack_public_path__ + "img/download.5769d58b.svg";